
/**
 * @abstract
 */
export default class Spritesheet {
    /**
     * @param {string} fileName 
     * @param {number} spriteSize 
     */
    constructor(fileName, spriteSize) {
        /**
         * @type {string}
         */
        this.fileName = fileName;

        /**
         * @type {boolean}
         */
        this.loaded = false;

        /**
         * @type {number}
         */
        this.spriteSize = spriteSize;

        const thisRef = this;

        /**
         * @type {Image}
         */
        this.image = new Image();
        this.image.onload = function() {
            thisRef.populateSpriteMap();
        };

    }

    /**
     * Subclasses must call this.
     */
    loadImage() {
        this.image.src = this.fileName;
    }

    /**
     * This is invoked on image load.
     * Subclasses must implement this
     * @abstract
     */
    populateSpriteMap() {
    }

}
